export const METADATA_KEY = "vt-metadata";

export const REQUIRED_METADATA_VALUES = [
  "workspaceId",
  "documentId",
  "entityType",
  "entityId",
];
const APP_SOURCE_KEY = "vt-app-source";
const IS_CLOUD_KEY = "vt-is-cloud";
const SEARCH_PARAMS = new URLSearchParams(window.location.search);
const SESSION_KEY = "vt-is-add-in";

// Catches scenario in development where refreshing the Add-In from
// the web inspector was losing the ?search param - so the solution
// was to simply add a SessionStorage value to keep assuming it's the Add-In.
const hasPrevAddInSession = sessionStorage.getItem(SESSION_KEY) === "true";

export const isAddInWebView = () => {
  const source = SEARCH_PARAMS.get(APP_SOURCE_KEY);
  return source === "add-in" || hasPrevAddInSession;
};

export const isAddInCloudMode = () => {
  const isCloudKey = SEARCH_PARAMS.get(IS_CLOUD_KEY) === "true";

  return isCloudKey || sessionStorage.getItem(IS_CLOUD_KEY) === "true";
};

export const setAddInViewSession = () => {
  sessionStorage.setItem(SESSION_KEY, "true");
};

export const setAddInIsCloudMode = () => {
  const isCloudKey = SEARCH_PARAMS.get(IS_CLOUD_KEY) === "true";

  sessionStorage.setItem(IS_CLOUD_KEY, isCloudKey);
};
